import {TextUtil} from "base/utilities";

export function useDepositoTable() {
    const tableColumns = [
        {
            id: "codigo",
            label: "Código",
            width: 10,
        },
        {
            id: "abastecemento_autonomo",
            label: "A.A.",
            width: 10,
            formatFunction: element =>
                TextUtil.formatBoolean(element.abastecemento_autonomo),
        },
        {
            id: "titular_label",
            label: "Titular",
            width: 15,
        },
        {
            id: "xestion_label",
            label: "Xestión",
            width: 15,
        },
        {
            id: "estado_label",
            label: "Estado",
            width: 10,
        },
        {
            id: "posicion_label",
            label: "Posición",
            width: 15,
        },
        {
            id: "material_label",
            label: "Material",
            width: 15,
        },
        {
            id: "planta_label",
            label: "Planta",
            width: 10,
        },
    ];

    return {tableColumns};
}
